export const CHECKPOINT_SPECIAL_ERROR = {
  copy: '"You do not possess enough gold for that blessing"',
  direction: 'outbound',
};

export const CHECKPOINT_PURCHASE = {
  copy: '"Excellent choice! %1 has been added to your deck"',
  direction: 'outbound',
};

export const CHECKPOINT_PURCHASE_ERROR = {
  copy: '"You do not possess enough gold to buy that card"',
  direction: 'outbound',
};
